import { ChangeDetectorRef, Component } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GlobalMessageService, GlobalMessageType, TranslationService } from '@spartacus/core';
import { MyCompanyAccountService } from 'src/app/services/feature/myCompanyAccount/my-company-account.service';
import { DeleteUserConfirmDialogComponent } from '../delete-user-confirm-dialog/delete-user-confirm-dialog.component';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-kb-manage-users',
  templateUrl: './kb-manage-users.component.html',
  styleUrls: ['./kb-manage-users.component.scss'],
  standalone: false
})
export class KbManageUsersComponent {
  userList: any;
  searchTerm: any;
  sortByName: boolean = false;
  sortByNameDesc: boolean = false;
  sortByEmail: boolean = false;
  sortByEmailDesc: boolean = false;
  sortByActive: boolean = false;
  sortByActiveDesc: boolean = false;
  totalResult: any;
  currentPage: number = 0;
  private destroy$ = new Subject<void>();

  constructor(private myCompanyAccountService: MyCompanyAccountService,
    private globalMessageService: GlobalMessageService,
    private cdr: ChangeDetectorRef,
    private router: Router, private translationService: TranslationService,
    private dialog: MatDialog) {

  }

  ngOnInit() {
    this.getUsers();
  }

  setDisable(userId) {
    this.myCompanyAccountService.setDisable(userId).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      if (data.status === 'SUCCESS') {
        let updatedKey = ''
        this.translationService.translate(data?.['message'])
          .pipe(takeUntil(this.destroy$)).subscribe((key) => {
            if (key.includes('{0}')) {
              updatedKey = key.replace('{0}', data?.['errorValue1']);
            }
          })
        this.globalMessageService.add(
          updatedKey, GlobalMessageType.MSG_TYPE_INFO
        );
        this.getUsers();
      }
    })
  }

  setEnable(userId) {
    this.myCompanyAccountService.setEnable(userId).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      //message
      if (data.status === 'SUCCESS') {
        let updatedKey = '';
        this.translationService.translate(data?.['message'])
          .pipe(takeUntil(this.destroy$)).subscribe((key) => {
            if (key.includes('{0}')) {
              updatedKey = key.replace('{0}', data?.['errorValue1']);
            }
          })
        this.globalMessageService.add(
          updatedKey, GlobalMessageType.MSG_TYPE_INFO
        );
        this.getUsers();
      }
    })
  }

  sortDevice(ev) {
    this.getUsers('', this.currentPage, ev.target.value);
  }

  getUsers(searchText?, currentPage?, sortType?) {

    this.currentPage = currentPage;
    this.myCompanyAccountService.getManageUsers(searchText, currentPage, sortType).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.userList = data;
      this.translationService.translate('common.text_company_manageUser_page_totalResults')
        .pipe(takeUntil(this.destroy$)).subscribe((key) => {
          if (key.includes('{0}')) {
            this.totalResult = key.replace('{0}', data?.searchPageData?.pagination.totalResults);
          }
        })
      this.cdr.detectChanges();
    })
  }

  searchUser() {
    this.getUsers(this.searchTerm);
  }

  editUser(userId) {
    this.router.navigate(['organizationManagement'], {
      queryParams: { user: userId },
    });
  }

  changePageCustom(e, data) {
    this.getUsers('', e)
  }

  sort(type) {
    if (type == 'name') {
      if ((!this.sortByName && !this.sortByNameDesc) || this.sortByNameDesc) {
        this.getUsers('', 0, 'byName');
        this.sortByName = true;
        this.sortByNameDesc = false;
      } else if (this.sortByName) {
        this.getUsers('', 0, 'byNameDesc');
        this.sortByNameDesc = true;
        this.sortByName = false;
      }
      this.sortByEmail = false;
      this.sortByEmailDesc = false;
      this.sortByActive = false;
      this.sortByActiveDesc = false;
    }
    if (type == 'email') {
      if ((!this.sortByEmail && !this.sortByEmailDesc) || this.sortByEmailDesc) {
        this.getUsers('', 0, 'byEmail');
        this.sortByEmail = true;
        this.sortByEmailDesc = false;
      } else if (this.sortByEmail) {
        this.getUsers('', 0, 'byEmailDesc');
        this.sortByEmail = false;
        this.sortByEmailDesc = true;
      }
      this.sortByNameDesc = false;
      this.sortByName = false;
      this.sortByActive = false;
      this.sortByActiveDesc = false;
    }
    if (type == 'active') {
      if ((!this.sortByActive && !this.sortByActiveDesc) || this.sortByActiveDesc) {
        this.getUsers('', 0, 'byActive');
        this.sortByActive = true;
        this.sortByActiveDesc = false;
      } else if (this.sortByActive) {
        this.getUsers('', 0, 'byActiveDesc');
        this.sortByActive = false;
        this.sortByActiveDesc = true;
      }
      this.sortByNameDesc = false;
      this.sortByName = false;
      this.sortByEmail = false;
      this.sortByEmailDesc = false;
    }
  }

  retriggerEmail(user) {
    this.myCompanyAccountService.retriggerEmail(user).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      if (data.status === 'SUCCESS') {
        let updatedKey = '';
        this.translationService.translate(data?.['message'])
          .pipe(takeUntil(this.destroy$)).subscribe((key) => {
            if (key.includes('{0}')) {
              updatedKey = key.replace('{0}', user);
            }
          })
        this.globalMessageService.add(
          updatedKey, GlobalMessageType.MSG_TYPE_INFO
        );
      }
    })
  }

  deleteUser(userId) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = userId;
    const dialogRef = this.dialog.open(DeleteUserConfirmDialogComponent, dialogConfig);
    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        if (data.status === 'SUCCESS') {
          let updatedKey = '';
          this.translationService.translate(data?.['message'])
            .pipe(takeUntil(this.destroy$)).subscribe((key) => {
              if (key.includes('{0}')) {
                updatedKey = key.replace('{0}', userId);

              }
            })
          this.globalMessageService.add(
            updatedKey, GlobalMessageType.MSG_TYPE_INFO
          );
          this.getUsers();
        }
      }
    );
  }

  addUser() {
    this.router.navigate(['add-user']);
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
